import {useEffect, useState} from 'react'
import {Icon} from 'src/common/Icon'
import {THINKING_MESSAGES} from './constants'

export function ThinkingState() {
  const [msgIndex, setMsgIndex] = useState(0)
  const [dots, setDots] = useState(1)

  // Cycle through thinking messages and animate the dot counter
  useEffect(() => {
    const msgTimer = setInterval(() => setMsgIndex((i) => (i + 1) % THINKING_MESSAGES.length), 3000)
    const dotTimer = setInterval(() => setDots((d) => (d % 3) + 1), 500)

    return () => {
      clearInterval(msgTimer)
      clearInterval(dotTimer)
    }
  }, [])

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '16px 0 8px',
        borderTop: '1px solid rgba(0,0,0,0.04)',
        marginTop: 4,
      }}
    >
      <span
        className="flex size-5 shrink-0 animate-epg-prep-pulse items-center justify-center rounded-full"
        style={{background: 'linear-gradient(135deg, rgba(180,255,68,0.3), rgba(180,255,68,0.1))'}}
      >
        <Icon name="sparkle" className="h-[9px] w-[9px]" />
      </span>
      <span key={msgIndex} className="animate-epg-msg-fade-3s text-[12px] font-medium text-black/45">
        {THINKING_MESSAGES[msgIndex]}
        {'.'.repeat(dots)}
      </span>
    </div>
  )
}
